module.exports = __webpack_public_path__ + "images/file_icons_v2/wav-81c292f93ce5bf4e2c0fc9136e995b4a.svg";